import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export function useUnreadQuestionsCount(eventId) {
    const selector = useCallback((state) => state.events[eventId]?.questions.unreadQuestions, [eventId]);
    return useSelector(selector) ?? 0;
}
